<template>
  <div class="wrapper">
    <div class="mtd">
      <img src="@/assets/image/icon-calenda.svg" />
      <div>This Month</div>
    </div>
    <div class="text">
      <div>compared to</div>
    </div>
    <div class="previous">Previous Period</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  margin-left: auto;
  white-space: nowrap;
  flex: 0 !important;
}
.wrapper > :not(:first-child) {
  margin-left: 16px;
}
.text {
  font-size: 16px;
  line-height: 24px;
  color: #969696;
}
.mtd {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #1c1c1c;
  font-family: Inter-regular;
  padding: 8px 12px;
  display: flex;
  align-items: center;
}
.mtd > img {
  margin-right: 8px;
}
.previous {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 16px;
  line-height: 24px;
  color: #585757;
}
</style>
